import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { Icons, Typography, useTheme } from '@hmsexp/component-library';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const { palette } = useTheme();
  const getPageNumbers = () => {
    if (totalPages <= 7) {
      return [...Array(totalPages).keys()].map(n => n + 1);
    }

    const pages = [];
    if (currentPage <= 4) {
      pages.push(1, 2, 3, 4, 5, '...', totalPages);
    } else if (currentPage >= totalPages - 3) {
      pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
    }
    return pages;
  };

  const renderPageButton = (page, index) => {
    const isCurrent = page === currentPage;
    const isEllipsis = page === '...';
    return (
      <TouchableOpacity
        key={`${page}-${index}`}
        disabled={isEllipsis || isCurrent}
        onPress={() => !isEllipsis && onPageChange(page)}
        style={{
          marginHorizontal: 4,
          width: 40,
          height: 40,
          borderRadius: 20,
          backgroundColor: isCurrent ? palette.hyperlinkBackgroundLow : null,
          borderWidth: 1,
          borderColor: '#ccc',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Typography variant='subtitle1'  fontWeightType='regular' style={{ lineHeight: 40 }}>{page}</Typography>
      </TouchableOpacity>
    );
  };

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 16 }}>
      <TouchableOpacity
        disabled={currentPage === 1}
        onPress={() => onPageChange(currentPage - 1)}
        style={{
          marginHorizontal: 4,
          borderRadius: 20,
          width: 40,
          height: 40,
          backgroundColor: currentPage === 1 ? palette.primaryBackgroundLow : null,
          borderWidth: 1,
          borderColor: '#ccc',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Icons.ChevronLeft />
      </TouchableOpacity>

      {getPageNumbers().map((page, idx) => renderPageButton(page, idx))}

      <TouchableOpacity
        disabled={currentPage === totalPages}
        onPress={() => onPageChange(currentPage + 1)}
        style={{
          marginHorizontal: 4,
          borderRadius: 20,
          width: 40,
          height: 40,
          backgroundColor: currentPage === totalPages ? palette.primaryBackgroundLow : null,

          borderWidth: 1,
          borderColor: '#ccc',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Icons.ChevronRight />
      </TouchableOpacity>
    </View>
  );
};

export default Pagination;
